import { PageHeader } from "@/components/page-header";
import { CsvImporter } from "@/components/csv-importer";

type Row = { name?: string; email?: string; phone?: string; linkedinUrl?: string; location?: string; visaStatus?: string; benchStatus?: string; skills?: string; source?: string };

const FIELD_MAP: Record<string, keyof Row> = {
  name: "name", "full name": "name",
  email: "email",
  phone: "phone", mobile: "phone",
  linkedin: "linkedinUrl", "linkedin url": "linkedinUrl",
  location: "location", city: "location",
  visa: "visaStatus", "visa status": "visaStatus",
  "bench status": "benchStatus", status: "benchStatus",
  skills: "skills", technologies: "skills", stack: "skills",
  source: "source",
};

export default function CandidateImportPage() {
  return (
    <>
      <PageHeader
        title="Import Candidates"
        description="CSV headers: name, email, phone, linkedin, location, visa status, bench status, skills (comma-separated), source."
      />
      <CsvImporter<Row>
        module="Candidates"
        endpoint="/candidates/bulk-import"
        backTo="/candidates"
        listQueryKey={["/candidates"]}
        fieldMap={FIELD_MAP}
        requiredField="name"
        description="Dedupes by email. Skills column should be comma-separated (e.g. 'React, Node, AWS')."
        previewColumns={[
          { field: "name", label: "Name" },
          { field: "email", label: "Email" },
          { field: "visaStatus", label: "Visa" },
          { field: "skills", label: "Skills" },
        ]}
      />
    </>
  );
}
